
export const getAllSiteVariables = () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let variables = []
    base('variable_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: "Site Variables",
    }).eachPage((records, fetchNextPage) => {
        records.forEach(function(record) {
            variables.push({
                "name": record["fields"]["variable_name"],
                "options": record["fields"]["variable_option_label"],
            })
        });
    });

    return variables;
}

export const getAllSpaceVariables = () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let variables = []
    base('variable_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: "Space Variables",
    }).eachPage((records, fetchNextPage) => {
        records.forEach(function(record) {
            variables.push({
                "name": record["fields"]["variable_name"],
                "options": record["fields"]["variable_option_label"],
            })
        });
    });

    return variables;
}

export const getCollectionMethods = () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let methods = []
    base('collection_method_dim').select({
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {
        records.forEach(function(record) {
            methods.push(record["fields"]["collection_method_name"])
        });
    });

    return methods;
}

export const getUnits = () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let units = []
    base('unit_dim').select({
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {
        records.forEach(function(record) {
            units.push({
                "name": record["fields"]["unit_name"],
                "brick_unit": record["fields"]["brick_unit"],
            })
        });
    });

    return units;
}

export const getPotentialVariables = async (context) => {
    // TODO(mike): make this more generic
    var Airtable = require('airtable');
    var base = new Airtable({ apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe' }).base('app7kfG35eQYRupcU');

    let upperContext = context.charAt(0).toUpperCase() + context.slice(1).toLowerCase();
    //"SEARCH('" + district + "',{District Name})"
    let contextFilter = ""
    if (["Site", "Building", "Space", "Zone", "Outdoor Area"].includes(upperContext) )
        contextFilter = "SEARCH('" + upperContext + "',ARRAYJOIN({valid_location_types}))";
    else if (upperContext === "Equipment")
        contextFilter = `{valid_equipment_types} != ""`
    else contextFilter = `SEARCH('FEAT', {variable_reference_id})`


    const variables = [];

    return new Promise((resolve, reject) => {
        base('variable_dim')
            .select({
                maxRecords: 5000,
                filterByFormula: contextFilter,
            })
            .eachPage(
                (records, fetchNextPage) => {
                    records.forEach(function (record) {
                        let variableOptions = new Set();
                        record['fields']['variable_option_label'] &&
                            record['fields']['variable_option_label'].forEach((label) => {
                                if (
                                    !(
                                        label === 'Primary School' ||
                                        label === 'Secondary School' ||
                                        label === 'Non-residential'
                                    )
                                )
                                    variableOptions.add(label);
                            });
                        variables.push({
                            name: record['fields']['variable_name'],
                            description: record['fields']['variable_desc'],
                            options: Array.from(variableOptions),
                        });
                    });
                    fetchNextPage();
                },
                (err) => {
                    if (err) {
                        console.error(err);
                        reject(err);
                        return;
                    }
                    resolve(variables);
                },
            );
    });
};

export const getClimateZones = () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let zones = []
    base('climate_zone_lookup').select({
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {
        records.forEach(function(record) {
            if (!zones.find(z => z === record["fields"]["climate_zone_text"])) {
                zones.push(record["fields"]["climate_zone_text"])
            }

        });
    });

    return zones;
}

export const getNAICSCodes = () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let codes = []
    base('naics_dim').select({
        maxRecords: 500,
    }).eachPage((records, fetchNextPage) => {
        records.forEach(function(record) {
            codes.push({
                name: record["fields"]["naics_lookup"],
                value:  record["fields"]["naics_code"],
            });
        });

        fetchNextPage();
    });

    return codes;
}
